var _circle, _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowBuyStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "url(#paint0_linear_319_7)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_319_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H56V56H16V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_319_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4219 55.8828C34.6808 55.8828 34.8906 55.6729 34.8906 55.4141V36C34.8906 35.7411 34.6808 35.5312 34.4219 35.5312C34.163 35.5312 33.9531 35.7411 33.9531 36V55.4141C33.9531 55.6729 34.163 55.8828 34.4219 55.8828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5781 55.8828C37.837 55.8828 38.0469 55.6729 38.0469 55.4141V36C38.0469 35.7411 37.837 35.5312 37.5781 35.5312C37.3192 35.5312 37.1094 35.7411 37.1094 36V55.4141C37.1094 55.6729 37.3192 55.8828 37.5781 55.8828Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9531 50.2578C25.212 50.2578 25.4219 50.0479 25.4219 49.7891V36.4688H46.5817V39.856C46.5817 40.1149 46.7916 40.3248 47.0505 40.3248C47.3094 40.3248 47.5192 40.1149 47.5192 39.856V36C47.5192 35.7411 47.3094 35.5312 47.0505 35.5312H24.9531C24.6942 35.5312 24.4844 35.7411 24.4844 36V49.7891C24.4844 50.0479 24.6942 50.2578 24.9531 50.2578Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_319_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H56V56H16V16Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_319_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4844 55.4141C24.4844 55.6729 24.6942 55.8828 24.9531 55.8828H47.0505C47.3094 55.8828 47.5192 55.6729 47.5192 55.4141V42.6058C47.5192 42.3469 47.3094 42.137 47.0505 42.137C46.7916 42.137 46.5817 42.3469 46.5817 42.6058V54.9453H25.4219V52.5346C25.4219 52.2757 25.212 52.0659 24.9531 52.0659C24.6942 52.0659 24.4844 52.2757 24.4844 52.5346V55.4141Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8521 33.1752C40.0352 33.3583 40.332 33.3583 40.5151 33.1752L42.2512 31.4389C42.4343 31.2559 42.4343 30.9591 42.2512 30.776C42.0682 30.593 41.7714 30.593 41.5883 30.7761L39.8521 32.5123C39.6691 32.6954 39.6691 32.9922 39.8521 33.1752Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3248 33.1752C43.5079 33.3583 43.8046 33.3583 43.9877 33.1752L46.9303 30.2326C47.1133 30.0496 47.1133 29.7528 46.9303 29.5697C46.7472 29.3867 46.4504 29.3867 46.2674 29.5697L43.3248 32.5123C43.1417 32.6954 43.1417 32.9921 43.3248 33.1752Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1497 33.1752C32.3327 32.9922 32.3327 32.6954 32.1497 32.5123L30.4135 30.7761C30.2304 30.593 29.9336 30.593 29.7506 30.776C29.5675 30.9591 29.5675 31.2559 29.7506 31.4389L31.4867 33.1752C31.6698 33.3583 31.9666 33.3583 32.1497 33.1752Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6764 33.1752C28.8594 32.9921 28.8594 32.6954 28.6764 32.5123L25.7338 29.5697C25.5507 29.3867 25.2539 29.3867 25.0709 29.5697C24.8878 29.7528 24.8878 30.0496 25.0709 30.2326L28.0135 33.1752C28.1965 33.3583 28.4933 33.3583 28.6764 33.1752Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6563 23.416C47.9151 23.416 48.125 23.2061 48.125 22.9473V22.158C48.125 21.8991 47.9151 21.6892 47.6563 21.6892C47.3974 21.6892 47.1875 21.8991 47.1875 22.158V22.9473C47.1875 23.2061 47.3974 23.416 47.6563 23.416Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1875 23.9492C48.1875 24.2081 48.3974 24.418 48.6563 24.418H49.4455C49.7044 24.418 49.9142 24.2081 49.9142 23.9492C49.9142 23.6903 49.7044 23.4805 49.4455 23.4805H48.6563C48.3974 23.4805 48.1875 23.6903 48.1875 23.9492Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6563 26.209C47.9151 26.209 48.125 25.9991 48.125 25.7402V24.951C48.125 24.6921 47.9151 24.4823 47.6563 24.4823C47.3974 24.4823 47.1875 24.6921 47.1875 24.951V25.7402C47.1875 25.9991 47.3974 26.209 47.6563 26.209Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3945 23.9492C45.3945 24.2081 45.6044 24.418 45.8633 24.418H46.6525C46.9114 24.418 47.1213 24.2081 47.1213 23.9492C47.1213 23.6903 46.9114 23.4805 46.6525 23.4805H45.8633C45.6044 23.4805 45.3945 23.6903 45.3945 23.9492Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_319_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H56V56H16V16Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_319_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7656 17.8438C26.0245 17.8438 26.2344 17.6339 26.2344 17.375V16.5858C26.2344 16.3269 26.0245 16.117 25.7656 16.117C25.5067 16.117 25.2969 16.3269 25.2969 16.5858V17.375C25.2969 17.6339 25.5067 17.8438 25.7656 17.8438Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5039 18.377C23.5039 18.6358 23.7138 18.8457 23.9727 18.8457H24.7619C25.0208 18.8457 25.2306 18.6358 25.2306 18.377C25.2306 18.1181 25.0208 17.9082 24.7619 17.9082H23.9727C23.7138 17.9082 23.5039 18.1181 23.5039 18.377Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7656 20.6367C26.0245 20.6367 26.2344 20.4269 26.2344 20.168V19.3787C26.2344 19.1199 26.0245 18.91 25.7656 18.91C25.5067 18.91 25.2969 19.1199 25.2969 19.3787V20.168C25.2969 20.4269 25.5067 20.6367 25.7656 20.6367Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2969 18.377C26.2969 18.6358 26.5067 18.8457 26.7656 18.8457H27.5549C27.8138 18.8457 28.0237 18.6358 28.0237 18.377C28.0237 18.1181 27.8138 17.9082 27.5549 17.9082H26.7656C26.5067 17.9082 26.2969 18.1181 26.2969 18.377Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_319_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H56V56H16V16Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_319_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2825 36.3315C25.4656 36.1484 25.4656 35.8516 25.2825 35.6685L18.827 29.213L19.5845 28.4553L27.4607 36.3315C27.6438 36.5145 27.9406 36.5145 28.1236 36.3315C28.3067 36.1484 28.3067 35.8516 28.1236 35.6685L19.916 27.461C19.8281 27.3731 19.7088 27.3237 19.5845 27.3237C19.4602 27.3237 19.341 27.3731 19.2531 27.461L17.8326 28.8815C17.6495 29.0646 17.6496 29.3614 17.8326 29.5444L24.6196 36.3315C24.8027 36.5145 25.0995 36.5145 25.2825 36.3315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8756 36.3315C44.0586 36.5145 44.3554 36.5145 44.5385 36.3315L52.4147 28.4553L53.1723 29.213L46.7167 35.6685C46.5336 35.8516 46.5336 36.1484 46.7167 36.3315C46.8997 36.5145 47.1965 36.5145 47.3796 36.3315L54.1666 29.5444C54.3497 29.3614 54.3497 29.0646 54.1666 28.8815L52.7462 27.461C52.6582 27.3731 52.539 27.3237 52.4147 27.3237C52.2904 27.3237 52.1711 27.3731 52.0832 27.461L43.8756 35.6685C43.6925 35.8516 43.6925 36.1484 43.8756 36.3315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3151 26.377C34.7894 26.377 34.3633 25.9508 34.3633 25.4252C34.3633 25.1663 34.1534 24.9564 33.8945 24.9564C33.6356 24.9564 33.4258 25.1663 33.4258 25.4252C33.4258 26.4686 34.2717 27.3145 35.3151 27.3145H36.5252C37.6558 27.3145 38.5723 26.3978 38.5723 25.2673C38.5723 24.1367 37.6558 23.2202 36.5252 23.2202H35.4729C34.8601 23.2202 34.3633 22.7233 34.3633 22.1105C34.3633 21.4977 34.8601 21.0009 35.4729 21.0009H36.683C37.2086 21.0009 37.6348 21.427 37.6348 21.9527C37.6348 22.2116 37.8446 22.4215 38.1035 22.4215C38.3624 22.4215 38.5723 22.2116 38.5723 21.9527C38.5723 20.9093 37.7264 20.0634 36.683 20.0634H35.4729C34.3423 20.0634 33.4258 20.98 33.4258 22.1105C33.4258 23.241 34.3423 24.1577 35.4729 24.1577H36.5252C37.138 24.1577 37.6348 24.6544 37.6348 25.2673C37.6348 25.8801 37.138 26.377 36.5252 26.377H35.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 21.001C36.2589 21.001 36.4688 20.7911 36.4688 20.5322V18.9539C36.4688 18.695 36.2589 18.4851 36 18.4851C35.7411 18.4851 35.5312 18.695 35.5312 18.9539V20.5322C35.5312 20.7911 35.7411 21.001 36 21.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 28.8926C36.2589 28.8926 36.4688 28.6827 36.4688 28.4238V26.8455C36.4688 26.5866 36.2589 26.3767 36 26.3767C35.7411 26.3767 35.5312 26.5866 35.5312 26.8455V28.4238C35.5312 28.6827 35.7411 28.8926 36 28.8926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4297 23.6884C28.4297 27.8699 31.8196 31.2598 36.0012 31.2598C40.1828 31.2598 43.5727 27.8699 43.5727 23.6884C43.5727 19.5067 40.1828 16.1169 36.0012 16.1169C34.4441 16.1169 32.9953 16.5874 31.7914 17.3942C31.5763 17.5383 31.5188 17.8295 31.6629 18.0445C31.8071 18.2596 32.0982 18.3171 32.3133 18.173C33.3676 17.4665 34.6356 17.0544 36.0012 17.0544C39.665 17.0544 42.6352 20.0245 42.6352 23.6884C42.6352 27.3521 39.665 30.3223 36.0012 30.3223C32.3373 30.3223 29.3672 27.3521 29.3672 23.6884C29.3672 22.3163 29.7831 21.0429 30.4959 19.9856C30.6406 19.7709 30.5839 19.4796 30.3692 19.3349C30.1545 19.1902 29.8632 19.2469 29.7185 19.4616C28.9047 20.6689 28.4297 22.1238 28.4297 23.6884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_7",
    x1: 10.9149,
    y1: -1.86667e-7,
    x2: 71.6748,
    y2: 17.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowBuyStep3);
export default __webpack_public_path__ + "static/media/How-Buy-Step-3..d9d808bc8833df3d2ed5d33c465ac680.svg";
export { ForwardRef as ReactComponent };